<template>
  <div>
    <!-- <v-dialog v-model="myloadingvariable" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog> -->

    <v-dialog v-model="alert.type" max-width="390" transition="scale-transition">
      <v-card>
        <v-card-title :class="alert.color">
          {{ alert.title }}
        </v-card-title>

        <v-card-text>
          {{ alert.message }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="alert.type = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container v-if="!isLocation && myloadingvariable">
      <!-- <v-card>
        <v-card-title class="headline">Select Date</v-card-title>

        <v-row justify="center">
          <v-date-picker
            v-model="editedItem1.date"
            year-icon="mdi-calendar-blank"
            prev-icon="mdi-skip-previous"
            next-icon="mdi-skip-next"
          ></v-date-picker>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeMap">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="getPlot">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card> -->
      <!-- dateee -->
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="4">
            <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="editedItem1.date" label="Date" persistent-hint v-bind="attrs" v-on="on"
                  outlined></v-text-field>
              </template>
              <v-date-picker v-model="editedItem1.date" no-title @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="6"> </v-col>

          <v-col cols="12" sm="6" md="2" class="text-right">
            <v-btn color="primary" dark class="my-3" @click="getDateWiseUserList()">
              Apply filter
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <!-- end dateee -->
      <v-data-table :headers="headers" :items="user" sort-by="user" class="elevation-1 col-12 col-md-12">
        <!-- <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>User</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialogMap" max-width="800px">
              <v-card>
                <v-card-title class="headline">Select Date</v-card-title>

                <v-row justify="center">
                  <v-date-picker
                    v-model="editedItem1.date"
                    year-icon="mdi-calendar-blank"
                    prev-icon="mdi-skip-previous"
                    next-icon="mdi-skip-next"
                  ></v-date-picker>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeMap"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="getDateWiseUserList()"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template> -->
        <!-- <template v-slot:item.actions="{ item }"> -->
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn small class="ma-2 primary--text" style="width:100px;" outlined @click="dialogMapItem(item)">
            View Map
          </v-btn>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          {{ item.created_user[0].firstName }}
          {{ item.created_user[0].lastName }}
        </template>
        <template v-slot:[`item.distance`]="{ item }">
          <span v-if="item.created_user[0].distance != null"> {{ item.created_user[0].distance }} KM</span>
          <span v-else>
            Not available
          </span>
        </template>
        <template v-slot:[`item.min`]="{ item }">
          {{ new Date(item.min).toLocaleString() }}
        </template>
        <template v-slot:[`item.max`]="{ item }">
          {{ new Date(item.max).toLocaleString() }}
        </template>

        <template v-slot:no-data>
          <span>Sorry, No data available for selected date ☹ ☹ ☹ </span>
        </template>
      </v-data-table>
    </v-container>

    <v-container v-if="isLocation">
      <v-btn class="my-5" color="primary" @click="isLocation = false" dark large top left>
        Go Back
      </v-btn>
      <span>
        <p>
          Approximate distance traveled :
          <span bold> {{ total_distance.toFixed(2) }} KM. </span>
        </p>
      </span>
      <v-card class="">
        <!-- <div > -->
        <!-- :center="LatLng(47.41322, -1.219482)" -->
        <!-- <l-map
          :zoom="zoom"
          :center="getMapCenter(userLoc[0].location)"
          style="height:600px; width: 100%"
        >
          <l-tile-layer :url="url" /> -->
        <!-- <l-marker
            icon-url="../assets/marker.png"
            v-for="(loc, i) in userLoc"
            :key="i"
            :lat-lng="getLocation(loc.location)"
          >
           <l-tooltip
              :options="{
                permanent: true,
                interactive: true,
              }"
            >
              <div>{{ loc.current_date }}</div>
            </l-tooltip> -->
        <!-- <l-icon icon-size="2"  /> 
          </l-marker> -->

        <!-- <l-circle-marker
            :lat-lng="getLocation(loc.location)"
            :radius="circle.radius"
            :color="circle.color"
          >
          </l-circle-marker>-->
        <!-- </l-map> -->

        <l-map :zoom="zoom" :center="getMapCenter(userLoc[0].location)" style="height:600px; width: 100%">
          <l-tile-layer :url="url" />
          <l-marker v-for="(loc, i) in userLoc" :key="i" :lat-lng="getLocation(loc.location)">
            <l-tooltip :options="{
              permanent: true,
              interactive: true,
            }">
              <div>{{ new Date(loc.current_date).toLocaleString() }}</div>
              <!-- <div>{{ getTime(loc.current_date) }}</div> -->
            </l-tooltip>
          </l-marker>

          <l-polyline :lat-lngs="getPoligonLocations(userLoc)" color="red"></l-polyline>
        </l-map>
        <!-- </div> -->
      </v-card>
    </v-container>
    <v-container class="indicator" v-if="!myloadingvariable">
      <v-progress-circular :size="50" :width="5" color="orange" indeterminate></v-progress-circular>
    </v-container>
  </div>
</template>

<script>
// import axios from "axios";
import axios from "axios";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LTooltip, LPolyline } from "vue2-leaflet";

export default {
  components: {
    LMap,
    LTileLayer,
    LTooltip,
    LPolyline,
  },
  data: () => ({
    total_distance: 0,
    alert: {
      color: "info",
      title: null,
      message: null,
      type: null,
    },
    isLoading: true,
    circle: {
      center: [47.41322, -1.0482],
      radius: 2,
      color: "red",
    },
    // map
    zoom: 12,

    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    marker: latLng(47.41322, -1.219482),
    menu1: false,
    dialog: false,
    dialogDelete: false,
    myloadingvariable: false,
    headers: [
      {
        text: "Employee ID",
        align: "start",
        sortable: true,
        value: "created_user[0].employee_id",
        width: "130px",
      },
      {
        text: "Name",
        align: "start",
        sortable: true,
        value: "name",
      },
      {
        text: "Initial Time",
        align: "start",
        sortable: true,
        value: "min",
      },
      {
        text: "Final Time",
        align: "start",
        sortable: true,
        value: "max",
      },
      // {
      //   text: "Approximate distance traveled",
      //   align: "start",
      //   sortable: true,
      //   value: "distance",
      // },

      { text: "Actions", value: "actions", sortable: false, align: "end" },
    ],
    user_id: "",
    dialogMap: false,
    isLocation: false,
    user: [],
    userLoc: [],
    allRoles: [],
    states: [],
    editedIndex: -1,
    editedItem1: {
      date: new Date().toISOString().substr(0, 10),
    },
  }),
  computed: {},
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    getTime(date) {
      // return date.getTime();
      console.log(date);
      var d = new Date(date);
      // Indian time
      let utc = d.getTime() + d.getTimezoneOffset() * 60000;
      let nd = new Date(utc);
      //  End IST
      var offset = nd.getTimezoneOffset();
      d.setMinutes(d.getMinutes() - offset);
      return this.convertDateToUTC(d);
    },

    convertDateToUTC(date) {
      var d = new Date(date),
        h = "" + d.getHours(),
        m = "" + d.getMinutes(),
        s = "" + d.getSeconds();

      let ampm = " am";
      if (h > 12) {
        h -= 12;
        ampm = " pm";
      }

      return [h, m, s].join(" : ") + ampm;
    },

    async getDateWiseUserList() {
      await axios
        .patch(`user-location/user-list-date`, { date: this.editedItem1.date })
        .then((res) => {
          this.user = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
      this.myloadingvariable = true;
    },

    async initialize() {
      this.getDateWiseUserList();
      axios
        .get("states")
        .then((res) => {
          this.states = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
      axios
        .get("roles")
        .then((res) => {
          this.allRoles = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async dialogMapItem(item) {
      this.user_id = item.created_by;
      await this.getPlot();
    },

    getLocation(loc) {
      return latLng(loc.lat, loc.long);
    },
    getMapCenter(loc) {
      return [loc.lat, loc.long];
    },

    closeMap() {
      this.dialogMap = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async getPlot() {
      axios
        .patch(`user-location/date/${this.user_id}`, this.editedItem1)
        .then((res) => {
          this.userLoc = res.data;
          this.myloadingvariable = true;
          if (res.data.length > 0) {
            this.isLocation = true;
            this.calculateDistance(res.data);
          } else {
            this.alert.color = "red--text";
            this.alert.title = "Sorry";
            this.alert.message = "No Location found for selected user in this date";
            this.alert.type = true;
            // this.$swal(
            //   "Sorry, No Location found for selected user in this date"
            // );
          }
          this.closeMap();
        })
        .catch((err) => {
          console.log(err);
          this.closeMap();
        });
      this.dialogMap = false;
    },

    getPoligonLocations(plot_marks) {
      let arr = [];
      plot_marks.forEach((element) => {
        arr.push([element.location.lat, element.location.long]);
      });
      return arr;
    },
    async calculateDistance(data) {
      this.total_distance = 0;
      for (let i = 0; i < data.length - 1; i = i + 1) {
        this.total_distance =
          this.total_distance +
          this.distance(data[i].location.lat, data[i].location.long, data[i + 1].location.lat, data[i + 1].location.long);
      }
    },
    distance(lat1, lon1, lat2, lon2) {
      var p = 0.017453292519943295; // Math.PI / 180
      var c = Math.cos;
      var a = 0.5 - c((lat2 - lat1) * p) / 2 + (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2;
      let distance_points = 12742 * Math.asin(Math.sqrt(a));
      console.info(distance_points); // 2 * R; R = 6371 km

      return distance_points;
    },
  },
};
</script>

<style lang="scss">
.vue2leaflet-map {
  z-index: 1;
}

.v-progress-circular {
  position: absolute;
  top: 100%;
  left: 50%;
}

.indicator {
  height: 40vh;
}
</style>
